module.exports = __webpack_public_path__ + "img/SBS_IOS.9b8ff209.png";